class CartShippingProtection extends HTMLElement {
  constructor() {
    super();

    this.priceEl = this.querySelector(".js-protection-price");
    this.input = this.querySelector(".js-protection-input");

    this.protectionProduct = JSON.parse(
      this.querySelector("[data-protection-json]").textContent
    );

    this.validating = false;
  }

  connectedCallback() {
    this.defaultStatus = this.dataset.defaultStatus;

    this.validateShippingProtection(this.input.checked);
    // document.addEventListener('input', e => {
    //   if (e.target.closest('.js-protection-input')) {
    //     const checked = e.target.checked
    //     console.log(checked)
    //     localStorage.setItem('shippingProtection', checked)
    //     this.validateShippingProtection(checked)
    //   }
    // })
    this.input.addEventListener("input", this.onInputChange.bind(this));

    document.addEventListener(
      "theme:product:add",
      this.validateShippingProtection.bind(this)
    );
    document.addEventListener(
      "theme:cart:change",
      this.validateShippingProtection.bind(this)
    );
  }

  formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || "${{amount}}";

    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ",",
      decimal = "."
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", "");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  async getCart() {
    return fetch(`${theme.routes.cart_url}.js`, {
      credentials: "same-origin",
      method: "GET",
    }).then((response) => response.json());
  }

  async changeItem(key, qty) {
    return this._updateCart({
      url: ""
        .concat(`${theme.routes.cart_change_url}.js`, "?t=")
        .concat(Date.now()),
      data: JSON.stringify({
        id: key,
        quantity: qty,
      }),
    });
  }

  async refreshCart() {
    document.querySelector("cart-items").getCart();
  }

  async _updateCart(params) {
    return fetch(params.url, {
      method: "POST",
      body: params.data,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then(function (cart) {
        return cart;
      });
  }

  async validateShippingProtection(addProtection = true) {
    // To avoid multipe functions running

    this.validating = true;
    this.refreshRequired = false;

    let cart = await this.getCart();

    console.log(cart);

    const shippableItems = cart.items
      .filter((item) => !item.properties?._is_shipping_protection)
      .filter((item) => !item.properties?._is_gift_wrap)
      .filter((item) => item.requires_shipping);

    const subtotal = shippableItems
      .map((item) => item.final_line_price)
      .reduce((a, b) => a + b, 0);

    const protectionLine = cart.items.find(
      (item) => !!item.properties?._is_shipping_protection
    );

    const requiredProtection = this.protectionProduct.variants.find(
      (variant) => variant.cartMin <= subtotal && variant.cartMax > subtotal
    );
    console.log(requiredProtection);

    cart.items
      .filter(
        (item) =>
          (!!item.properties?._is_shipping_protection &&
            item.variant_id !== requiredProtection?.id) ||
          !requiredProtection
      )
      .filter((item) => item.requires_shipping)
      .forEach(async (line) => {
        await this.changeItem(line.key, 0);
        this.refreshRequired = true;
      });

    this.classList[shippableItems.length === 0 ? "add" : "remove"]("hidden");

    this.priceEl.innerHTML = this.formatMoney(
      requiredProtection?.price,
      theme.moneyFormat
    );

    this.classList[!!requiredProtection ? "remove" : "add"]("hide");

    if (
      protectionLine?.variant_id === requiredProtection?.id &&
      addProtection
    ) {
      this.validating = false;

      if (this.refreshRequired) this.refreshCart();
      return;
    }

    if (!!protectionLine) {
      await this.changeItem(protectionLine.key, 0);

      if (localStorage.getItem("shippingProtection") === "false") {
        this.refreshRequired = true;
      }
    }

    if (localStorage.getItem("shippingProtection") === "false") {
      this.validating = false;

      if (this.refreshRequired) this.refreshCart();
      return;
    }

    if (addProtection && !!requiredProtection) {
      if (
        this.defaultStatus === "ignore" &&
        !localStorage.getItem("shippingProtection") &&
        typeof addProtection?.type !== "undefined"
      )
        return;

      await this._updateCart({
        url: "/cart/add.js",
        data: JSON.stringify({
          items: [
            {
              id: requiredProtection.id,
              quantity: 1,
              properties: {
                _is_shipping_protection: true,
              },
            },
          ],
        }),
      });

      this.input.checked = true;
      this.validating = false;
      this.refreshRequired = true;
    }

    if (this.refreshRequired) this.refreshCart();
  }

  onInputChange(e) {
    const checked = e.target.checked;
    console.log(checked);
    localStorage.setItem("shippingProtection", checked);
    this.validateShippingProtection(checked);
  }
}

customElements.define("cart-shipping-protection", CartShippingProtection);